import {reason} from '../../reason.js';

export const activityDomainUri = 'activity';

export const failure = `${activityDomainUri}.errors.failure`;

export const activityRegistrationFailure = `${activityDomainUri}.errors.registration.failure`;
export const activityMissingFactory = `${activityDomainUri}.errors.missing_factory`;
export const activityFactoryAlreadyRegistered = `${activityDomainUri}.errors.factory_already_registered`;
export const activityOwnerCreationFailed = `${activityDomainUri}.errors.owner_creation`;
export const activityMissingActivityType = `${activityDomainUri}.errors.missing_type`;
export const activityInvalid = `${activityDomainUri}.errors.invalid_activity`;
export const activityIsChild = `${activityDomainUri}.errors.activity_is_child`;
export const activityInvalidPeer = `${activityDomainUri}.errors.invalid_peer`;
export const activityNotAuthorized = `${activityDomainUri}.errors.not_authorized`;
export const activityUnhandledMessage = `${activityDomainUri}.errors.unhandled_message`;

export const reasonPeerRemoved = reason(`${activityDomainUri}.peer-removed`, "Peer has been removed");
export const reasonActivityDestroyed = reason(`${activityDomainUri}.destroyed`, "Activity destroyed");
